import request from './request'

const Account = {

  getKycState() { 
    return request({
      url: `/v1/pluskyc/kyc/state`,
      method: "get",
    });
  }
};

export default Account